let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kNFvF"), load("gUZma")]).then(() => parcelRequire('amnp6'));